import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import initApp from '@m/utils/initApp';
import { captureReservationAttributionFromUrl } from '@m/utils/reservationFunnelContext';
import CustomerApp from 'apps/customer/CustomerApp';

// Sign-in and other entry routes replace the URL without its query string. Store UTMs,
// gclid, and start_domain/start_page first so later funnel events keep the marketing
// attribution instead of recording a fresh `direct` visit.
captureReservationAttributionFromUrl();

initApp('customer');

const root = createRoot(document.getElementById('root')!);

if (!navigator.cookieEnabled) {
  document.getElementById('initial-loader')?.remove();
  root.render(
    <div style={{ fontFamily: 'sans-serif', fontSize: 20, fontWeight: 'bold' }}>
      Please turn on cookies to use Metropolis.
    </div>,
  );
} else {
  root.render(
    <Sentry.ErrorBoundary>
      <CustomerApp />
    </Sentry.ErrorBoundary>,
  );
}
